export enum ValidationErrorMessages {
  required = 'Required field',
  contain40 = 'Can contain up to 40 characters',
  contain80 = 'Can contain up to 80 characters',
  contain200 = 'Can contain up to 200 characters',
  contain1000 = 'Can contain up to 1000 characters',
  containSimpleChars = 'Please use only letters, numbers and underscores',
  variableNameExists = 'Variable name already exists',
  startWithLetter = 'Variables should start with a letter',
  variableCodeAlreadyExists = 'Code already exists',
}
